import React from 'react';
import { Component } from 'react';
import { linkPlaceholder, placeholder } from '../../utils/TranslationUtils';
import confirmationData from '../../data/confirmationData';
import qrCodeSymbol from '../../static/img/test-drive.jpg';
import Constants from '../../data/constants';
import carImages from '../../data/carImages';

class ConfirmationBlock extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { location, model, formattedDate, formattedTime, duration } = this.props.values,
              { getData } = this.props;

        const countryCode = (typeof window.Tesla === "undefined") ? "US" : window.Tesla.country.toUpperCase();
        const confirmation = (typeof window.tesla !== "undefined") ? window.tesla.App.strings['Test_Drive/All'].content.confirmation : {};

        const data = getData();

        let locationInfo = null;
        if (data != null && typeof location !== "undefined" && location != null) {
            locationInfo = data[location].storeDetails;
        }

        const success = (locationInfo != null) && (model != null && typeof model !== "undefined") && (duration != null);
        const firstTxt = linkPlaceholder(
                            confirmation.firstTitle,
                            { LEARN_MORE: confirmation.firstTitleLbl },
                            '/support/test-drive'
                        );

        const showTradeinSection = confirmationData.showTradeinSection.includes(countryCode);
        const showQRCode = countryCode == "CN";

        return (
            <div className="confirmation-section">
                { success ?
                    <div>
                        <h1>{confirmation.thankYou}</h1>
                        <p dangerouslySetInnerHTML={{__html: firstTxt}}></p>
                        <p>
                            {placeholder(
                                confirmation.secondTitle,
                                { MODEL: model.replace("Model", "Model ") }
                            )}
                        </p>
                        <div className="confirmation-details-container">
                            <section className="confirmation-details">
                                <p className="title-style">{`${formattedDate} ${confirmation.atTxt} ${formattedTime}`}</p>
                                <p className="title-style">{`Tesla ${locationInfo.storeName}`}</p>
                                <p>{locationInfo.streetAddress}<br />{`${locationInfo.city}, ${locationInfo.stateProvince} ${locationInfo.zipCode}`}</p>
                                <p><a className="tds-link--primary" href={"/" + locationInfo.findUsId}>{confirmation.mapAndLocation}</a></p>
                            </section>
                            <section className="confirmation-image">
                                <img src={`${Constants().RESOURCE_BASE_URL}${carImages[model.toLowerCase()]}`} alt="car-model" />
                            </section>
                        </div>
                        {showTradeinSection ?
                            <section>
                                <p>{confirmation.tradeInQuote}</p>
                                <p>{confirmation.provideQuote}</p>
                                <div className='btn-container'>
                                    <a href="/tradein" className="tds-btn tds-btn--blue">{confirmation.next}</a>
                                </div>
                            </section>
                        : null}
                        {showQRCode ?
                            <p className='cn-confirmation'>{confirmation.qrText}<br /><img src={`${Constants().RESOURCE_BASE_URL}${qrCodeSymbol}`} /></p>
                        : null}
                    </div>
                    :
                    <div>
                        <h1>{confirmation.thankYou}</h1>
                        <p dangerouslySetInnerHTML={{__html: firstTxt}}></p>
                        <p>{confirmation.contactYouSoon}</p>
                    </div>
                }
            </div>
        )
    }
}

export default ConfirmationBlock
